var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        id: "modal_product_price_option",
        "hide-header": "",
        "hide-header-close": "",
        scrollable: "",
        centered: "",
        "modal-class": {
          "atm-modal-width": _vm.isAtm,
        },
        size: "lg",
        loading: _vm.loading,
      },
      on: { hidden: _vm.onHidden },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "b-row",
                {
                  staticClass:
                    "w-100 d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "b-col",
                    { staticClass: "d-flex justify-content-end" },
                    [
                      _c("e-button", {
                        staticClass: "mr-1",
                        class: {
                          "atm-btn": _vm.isAtm,
                        },
                        attrs: {
                          id: "modal_product_price_option-btn_cancel",
                          variant: "outline-primary",
                          text: _vm.$t("Voltar"),
                          "text-shortcuts": _vm.isAtm ? [] : ["ESC"],
                          busy: _vm.loading,
                        },
                        on: { click: _vm.onCancel },
                      }),
                      _c("e-button", {
                        class: {
                          "atm-btn": _vm.isAtm,
                        },
                        attrs: {
                          id: "modal_product_price_option-btn_confirm",
                          variant: "primary",
                          text: _vm.getConfirmButtonText,
                          "text-shortcuts": _vm.isAtm ? [] : ["CTRL", "ENTER"],
                          busy: _vm.loading,
                        },
                        on: { click: _vm.onConfirm },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c("div", { staticClass: "mt-1" }),
      _c(
        "div",
        {
          staticClass: "position-fixed",
          staticStyle: { "margin-top": "-24px", "z-index": "10" },
        },
        [
          _c("b-img", {
            staticClass: "position-absolute",
            staticStyle: {
              top: "-15px",
              left: "-20px",
              "object-fit": "contain",
            },
            attrs: { src: _vm.tieredPriceImg, width: "150", height: "150" },
          }),
        ],
        1
      ),
      _vm.loading
        ? [
            _c(
              "div",
              {
                staticClass: "d-flex justify-content-center align-items-center",
                staticStyle: { height: "200px" },
              },
              [_c("e-spinner")],
              1
            ),
          ]
        : _c(
            "FormulateForm",
            {
              ref: "formTieredPriceOption",
              attrs: { name: "formTieredPriceOption" },
              on: { submit: _vm.onConfirm },
            },
            [
              _c(
                "b-container",
                { staticClass: "d-flex flex-column gap-2" },
                [
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex gap-2 justify-content-center",
                          attrs: { md: "12" },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "product-img" },
                            [
                              _c("b-img", {
                                style: {
                                  height: "150px",
                                  width: "150px",
                                  objectFit: "contain",
                                },
                                attrs: {
                                  thumbnail: "",
                                  src:
                                    _vm.getSaleItemInfo.imageSquare ||
                                    _vm.noImage,
                                  alt:
                                    "Imagem " +
                                    (_vm.getSaleItemInfo.name || "sem imagem"),
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "h-100 d-flex flex-column",
                              staticStyle: { width: "400px" },
                            },
                            [
                              _c("div", [
                                _c("p", { staticClass: "h3" }, [
                                  _vm._v(
                                    " " + _vm._s(_vm.getSaleItemInfo.name) + " "
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "d-flex gap-2" }, [
                                _c("p", { staticClass: "h4" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.getSaleItemInfo.price
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                                _vm.getSaleItemInfo.hasOldPrice
                                  ? _c(
                                      "p",
                                      {
                                        staticClass:
                                          "h6 product-price-canceled",
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("currency")(
                                                _vm.getSaleItemInfo.oldPrice
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "mt-auto justify-content-end",
                                  staticStyle: { "max-width": "200px" },
                                },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "modalProductPriceOption_Quantity",
                                      type: "osk-number-with-buttons",
                                      name: "modalProductPriceOption_Quantity",
                                      validation: "min:1",
                                      "validation-messages": {
                                        min: _vm.$t(
                                          "Quantidade deve ser maior ou igual a 1."
                                        ),
                                        required: _vm.$t(
                                          "Por favor preencha a quantidade."
                                        ),
                                      },
                                      "is-osk-enabled": _vm.isAtm,
                                      "right-disabled": _vm.addButtonDisabled,
                                    },
                                    on: {
                                      onInput: _vm.onInput,
                                      leftClick: _vm.onMinusQuantity,
                                      rightClick: _vm.onPlusQuantity,
                                    },
                                    model: {
                                      value: _vm.localForm.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.localForm, "quantity", $$v)
                                      },
                                      expression: "localForm.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c("hr", { staticClass: "dropdown-divider" }),
                  _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        {
                          staticStyle: { "overflow-x": "auto" },
                          attrs: { md: "12" },
                        },
                        [
                          _c("FormulateInput", {
                            attrs: {
                              type: "number-stepper",
                              options: _vm.getTieredPrices,
                              "max-value": _vm.getSaleItemInfo.stock,
                              "invalid-option-message":
                                "Estoque insuficiente para quantidade selecionada.",
                            },
                            on: { input: _vm.onOptionSelect },
                            model: {
                              value: _vm.localForm.quantity,
                              callback: function ($$v) {
                                _vm.$set(_vm.localForm, "quantity", $$v)
                              },
                              expression: "localForm.quantity",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "b-col",
                        {
                          staticClass: "d-flex flex-column align-items-center",
                          attrs: { md: "12" },
                        },
                        [
                          _c("p", { staticClass: "h3" }, [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("currency")(
                                    _vm.getSaleItemInfo.tieredPrice.price,
                                    "-",
                                    2
                                  )
                                ) +
                                " "
                            ),
                          ]),
                          _c("p", { staticClass: "h5" }, [
                            _vm._v(
                              " A partir de " +
                                _vm._s(
                                  _vm.getSaleItemInfo.tieredPrice.quantityFrom
                                ) +
                                " unidade(s) "
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }